//box1 
$('.box1_item').hover(function(){
    if(window.innerWidth>750){
        $('.box1_item').css({width:'18.4%'})
        $(this).css({width:'45%'})
        $(this).find('span').css({transform:'scale(1.2)'})
        $('.box1Item_mask').css({width:'100%'})
        $(this).find('.box1Item_mask').css({width:'0'})
    }
},function(){
    $(this).find('span').css({transform:'scale(1)'})
})

//box2
if(window.innerWidth>750){
    new Swiper('.box2Swiper1', {
        speed:12000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //waitForTransition: false,
        },
        slidesPerView :5,
        loop:true
    })

    new Swiper('.box2Swiper2', {
        speed:12000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true
          //waitForTransition: false,
        },
        slidesPerView :5,
        loop:true
    })

    $('.box1_1')[0].classList.add('showUp')
}else{
    new Swiper('.box2Swiper1', {
        speed:8000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          //waitForTransition: false,
        },
        slidesPerView :1,
        loop:true
    })

    new Swiper('.box2Swiper2', {
        speed:8000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: true
          //waitForTransition: false,
        },
        slidesPerView :1,
        loop:true
    })
}